<template>
    <div class="history">
        <LoadingCommon v-if="isLoadingScreen" />
        <div v-else class="history__content">
            <h1 class="history__content-title">{{ getTranslatedText('Wager History') }}</h1>
            <div class="history_content-search">
                <div class="history_content-search-input">
                    <input v-model="keyword" class="" type="search" placeholder="Search" @blur="onSearchKeyWord" />
                    <div class="box-icon-search" @click="onSearchKeyWord">
                        <img class="icon-search" src="~ThemePath/img/search.png" />
                    </div>
                </div>
                <!-- <span class="history_content-search-balance">
                    {{ getTranslatedText("Balance: R 10,000.00") }}
                </span> -->
                <div class="history_content-select">
                    <select v-model="selectedStatus" @change="handleStatusChange">
                        <option value="">{{ getTranslatedText('Select Status') }}</option>
                        <option v-for="(s, index) in historyStatus" :key="index" :value="s.key">{{ s.value }}</option>
                    </select>
                </div>
            </div>

            <LoadingCommon v-if="isLoadingFilter" />
            <div class="history-empty" v-else-if="dataSource.length === 0">
                <span>{{ getTranslatedText('No data') }}</span>
            </div>
            <template v-else>
                <div class="table-container">
                    <template v-if="!isMobile">
                        <table class="table-history">
                            <thead>
                                <tr>
                                    <th>{{ getTranslatedText('Transaction ID') }}</th>
                                    <th>{{ getTranslatedText('Bet Date') }}</th>
                                    <th>{{ getTranslatedText('Bet Selection') }}</th>
                                    <th>{{ getTranslatedText('Result') }}</th>
                                    <th>{{ getTranslatedText('Wager') }}</th>
                                    <th>{{ getTranslatedText('Potential Return') }}</th>
                                    <th>{{ getTranslatedText('Winnings') }}</th>
                                    <th>{{ getTranslatedText('Status') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in dataSource" :key="index">
                                    <td>{{ item.transaction_id }}</td>
                                    <td>{{ formatDate(item.bet_date) }}</td>
                                    <td>
                                        <div class="table-item-selection" v-if="item.selection">
                                            <img
                                                :src="addTimestampToURL(item.selection.icon.active)"
                                                :alt="item.selection.number"
                                            />
                                            <b>nr {{ item.selection.number }} - {{ item.selection.title }}</b>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="table-item-selection" v-for="(value, i) in item.result" :key="i">
                                            <img :src="addTimestampToURL(value.icon.active)" :alt="value.number" />
                                            <b>nr {{ value.number }} - {{ value.title }}</b>
                                        </div>
                                    </td>
                                    <td>
                                        <span v-html="$store.state.accountSetting.currency.symbol"></span>
                                        {{ formatMoney(item.wager) }}
                                    </td>
                                    <td>
                                        <span v-html="$store.state.accountSetting.currency.symbol"></span>
                                        {{ formatMoney(item.potential) }}
                                    </td>
                                    <td>
                                        <span v-html="$store.state.accountSetting.currency.symbol"></span>
                                        {{ formatMoney(item.winnings) }}
                                    </td>
                                    <td>{{ item.status }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </template>
                    <div class="table-history__mobile" v-else>
                        <div class="table-history__mobile-content" v-for="(item, index) in dataSource" :key="index">
                            <div class="history__item">
                                <label class="history__item-label">{{ getTranslatedText('Transaction ID') }}</label>
                                <span class="history__item-value">{{ item.transaction_id }}</span>
                            </div>
                            <div class="history__item">
                                <label class="history__item-label">{{ getTranslatedText('Bet Date') }}</label>
                                <span class="history__item-value">{{ formatDate(item.bet_date) }}</span>
                            </div>
                            <div class="history__item">
                                <label class="history__item-label">{{ getTranslatedText('Bet Selection') }}</label>
                                <div class="history__item-selection" v-if="item.selection">
                                    <img
                                        :src="addTimestampToURL(item.selection.icon.active)"
                                        :alt="item.selection.number"
                                    />
                                    <b>nr {{ item.selection.number }} - {{ item.selection.title }}</b>
                                </div>
                            </div>
                            <div class="history__item">
                                <label class="history__item-label">{{ getTranslatedText('Result') }}</label>
                                <div class="history__item-selection" v-for="(value, i) in item.result" :key="i">
                                    <img :src="addTimestampToURL(value.icon.active)" :alt="value.number" />
                                    <b>nr {{ value.number }} - {{ value.title }}</b>
                                </div>
                            </div>
                            <div class="history__item">
                                <label class="history__item-label">{{ getTranslatedText('Wager') }}</label>
                                <span class="history__item-value">
                                    <span v-html="$store.state.accountSetting.currency.symbol"></span>
                                    {{ formatMoney(item.wager) }}</span
                                >
                            </div>
                            <div class="history__item">
                                <label class="history__item-label">{{ getTranslatedText('Potential Return') }}</label>
                                <span class="history__item-value">
                                    <span v-html="$store.state.accountSetting.currency.symbol"></span>
                                    {{ formatMoney(item.potential) }}</span
                                >
                            </div>
                            <div class="history__item">
                                <label class="history__item-label">{{ getTranslatedText('Winnings') }}</label>
                                <span class="history__item-value">
                                    <span v-html="$store.state.accountSetting.currency.symbol"></span>
                                    {{ formatMoney(item.winnings) }}</span
                                >
                            </div>
                            <div class="history__item">
                                <label class="history__item-label">{{ getTranslatedText('Status') }}</label>
                                <span class="history__item-value">{{ item.status }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <Pagination
                    v-model="currentPage"
                    :records="records"
                    @paginate="onClickPagination"
                    :per-page="parseInt(perPage)"
                />
            </template>
        </div>
    </div>
</template>
<script>
import languageMixins from '@/mixins/language/language-mixins'
import VersionCache from '@/mixins/version-cache/version-cache-mixins'

import gamesService from '@/services/games.service'
import LoadingCommon from '@/components/common/loading.vue'
import Pagination from 'vue-pagination-2'

import { isArrayEmpty, formatPrice, formatDateUTC } from '@/utils/utils'

const IS_DEV = process.env.VUE_APP_DEV
const VUE_APP_LIMIT_HISTORY = process.env.VUE_APP_LIMIT_HISTORY
export default {
    mixins: [languageMixins, VersionCache],
    components: { Pagination, LoadingCommon },
    data() {
        return {
            dataSource: [],
            historyStatus: [],
            selectedStatus: '',
            records: 0,
            isLoadingScreen: true,
            isLoadingFilter: false,
            currentPage: 1,
            perPage: VUE_APP_LIMIT_HISTORY || 10,
            keyword: '',
            isMobile: false,
        }
    },
    created() {
        if (!this.$store.state.isLogin) {
            const query = this.$route.query
            this.$router.push({ path: '/', query })
        }

        this.fetchdata()
        this.getStatusHistory()
        // check when use on mobile
        this.handleResize()
        window.addEventListener('resize', this.handleResize)
    },
    methods: {
        async fetchdata() {
            try {
                const limit = this.perPage
                const currentPage = this.currentPage
                const keyword = this.keyword
                const selectedStatus = this.selectedStatus

                const resp = await gamesService.getListHistory(currentPage, limit, keyword, selectedStatus)

                let data = !isArrayEmpty(resp.data) ? resp.data : []
                this.dataSource = data
                this.records = resp.paginator.total_count
                this.isLoadingFilter = false
                this.isLoadingScreen = false
            } catch (error) {
                this.dataSource = []
                this.isLoadingFilter = false
                this.isLoadingScreen = false
                if (parseInt(IS_DEV)) {
                    console.log(error)
                }
            }
        },

        async getStatusHistory() {
            const resp = await gamesService.getStatusHistory()
            if (resp.status == 'success') {
                this.historyStatus = Object.keys(resp.data).map((key) => ({ key, value: resp.data[key] }))
            }
        },

        handleStatusChange() {
            this.isLoadingFilter = true
            this.currentPage = 1
            this.fetchdata()
        },

        onSearchKeyWord() {
            this.isLoadingFilter = true
            this.currentPage = 1
            this.fetchdata()
        },

        onClickPagination(page) {
            this.isLoadingFilter = true
            this.currentPage = page
            this.fetchdata()
        },

        formatMoney(price) {
            return formatPrice(parseFloat(price))
        },

        formatDate(date) {
            const dateFormat = formatDateUTC(date)

            let valueDate = `${dateFormat.day}-${dateFormat.month}-${dateFormat.year} ${dateFormat.hour}:${dateFormat.minutes}:${dateFormat.seconds}`

            return valueDate
        },
        handleResize() {
            if (window.innerWidth <= 768) {
                this.isMobile = true
            } else {
                this.isMobile = false
            }
        },
    },
}
</script>

<style lang="scss">
@import '~ThemePath/scss/history/index.scss';
</style>
